var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.616 15.186a1.989 1.989 0 01-.969.53c-.07.038-3.236 1.325-3.238 1.326a2.046 2.046 0 01-2.157-.442 2 2 0 01-.443-2.157s1.291-3.168 1.327-3.238a1.978 1.978 0 01.53-.968l6.259-6.261a.25.25 0 00-.176-.427H3.7A3.118 3.118 0 00.579 6.667v13.765A3.117 3.117 0 003.7 23.549h13.761a3.118 3.118 0 003.118-3.118V8.826a.25.25 0 00-.427-.176zM21.431.451a1.974 1.974 0 00-1.415.557l-1.061 1.061a.5.5 0 000 .707L21.076 4.9a.5.5 0 00.707 0l1.06-1.061a2.02 2.02 0 000-2.828 2 2 0 00-1.412-.56z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.858 3.871a.516.516 0 00-.707 0l-6.363 6.365a.5.5 0 000 .707l2.121 2.121a.5.5 0 00.707 0L19.98 6.7a.5.5 0 000-.707z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.882 14.438a.5.5 0 00.168-.819L10.232 11.8a.5.5 0 00-.454-.137.5.5 0 00-.364.3L8.2 15a.5.5 0 00.65.65z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.2e4e06b0.svg";
export { ForwardRef as ReactComponent };